import { memo } from "react";

import { cn } from "@/lib/chillnn/cn";
import { LangCode } from "@/lib/gql/__generated__/graphql";

import { useNavigateLangCode } from "./hooks";

export type NavigatorProps = {
	default: string;
	i18n?: (landCode: LangCode) => string;
};

type Props = {
	navigator: NavigatorProps;
	activeLangCode: LangCode;
};

export type LangCodeForFeatureIslandHeaderProps = Props;

export const LangCodeForFeatureIslandHeader = memo(({ navigator, activeLangCode }: Props) => {
	const { handleClickNavigate } = useNavigateLangCode(navigator);

	const isDefault = activeLangCode === LangCode.Default;
	const isEn = activeLangCode === LangCode.En;

	return (
		<div className="flex gap-4 text-sm laptop:text-base">
			<button className={cn(isDefault && "font-semibold")} onClick={handleClickNavigate(LangCode.Default)}>
				日本語
			</button>
			<p>/</p>
			<button className={cn(isEn && "font-semibold")} onClick={handleClickNavigate(LangCode.En)}>
				英語
			</button>
		</div>
	);
});
